import { render, staticRenderFns } from "./edit-product.vue?vue&type=template&id=6568a9e6&scoped=true&"
import script from "./edit-product.vue?vue&type=script&lang=js&"
export * from "./edit-product.vue?vue&type=script&lang=js&"
import style0 from "./edit-product.vue?vue&type=style&index=0&id=6568a9e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6568a9e6",
  null
  
)

export default component.exports